import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaUserFriends, FaBookReader, FaHandHoldingHeart, FaWhatsapp } from 'react-icons/fa';
import Gallery from '../components/Gallery';
import logo from '../assets/img/gifs/LogoGif.gif';
import cocina from '../assets/img/hero/imagen_cocina.jpg'
import temperley from '../assets/img/hero/temperley_frente_nwsp.jpg'
import glew from '../assets/img/hero/glew_frente_nwsp.jpg'
import feria from '../assets/img/hero/feria.jpg'
import temperley_bw from '../assets/img/TemperleyBW.jpg'
import temperley_frente from '../assets/img/Temperley_Frente.jpg'
import glew_frente from '../assets/img/Glew_Frente.jpg'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/FXqBCP_4gNcaEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const LandingPage = () => {
  // Imágenes para la galería (en producción se reemplazarían por imágenes reales)
  const galleryImages = [
    { src: temperley, alt: 'Temperley Gif' },
    { src: glew, alt: 'Glew Gif' },
    { src: cocina, alt: 'Cocina Gif' },
    { src: feria, alt: 'Feria Gif' }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
      {/* Hero Section with slider */}
      <section className="hero">
        <div className="hero-image-slider">
          <img
            src={galleryImages[currentIndex].src}
            alt={galleryImages[currentIndex].alt}
            className="slider-image"
          />
          <div className="slider-indicators">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Ir a imagen ${index + 1}`}
              />
            ))}
          </div>
        </div>
        <div className="hero-content">
          <div className="hero-logo">
            <img src={logo} alt="Mi Lugar - Centro de Día y Centro Educativo Terapéutico" />
          </div>
          <div className="hero-buttons">
            <Link to="/contacto" className="btn">Contáctanos</Link>
            <a
              href="#"
              className="btn btn-accent"
              onClick={(e) => {
                e.preventDefault();
                gtag_report_conversion("https://wa.me/5491165651675");
              }}
            >
              <FaWhatsapp /> WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Acerca de nosotros */}
      <section className="section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Sobre Nosotros</h2>
              <p>Mi Lugar es un Centro de Día y Centro Educativo Terapéutico fundado por la Lic. Mirtha Wechsung en 1982. Contamos con más de 40 años de experiencia brindando atención especializada a niños y jóvenes con discapacidad.</p>
              <p>Nuestro enfoque se centra en el desarrollo integral de cada individuo, potenciando sus habilidades y fomentando su autonomía a través de metodologías terapéuticas innovadoras y un equipo profesional altamente capacitado.</p>
              <p>En Mi Lugar ofrecemos un espacio de contención, aprendizaje y crecimiento, donde cada niño y joven puede desarrollar al máximo sus capacidades en un ambiente cálido y seguro.</p>
              <div className="hero-buttons" style={{ justifyContent: 'flex-start', marginTop: '20px' }}>
                <Link to="/tratamientos" className="btn">Conoce nuestros tratamientos</Link>
              </div>
            </div>
            <div className="about-image">
              <img src= {temperley_bw} alt="Mi Lugar - Centro Terapéutico" />
            </div>
          </div>
        </div>
      </section>

      {/* Características principales */}
      <section className="section" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">¿Por qué elegirnos?</h2>
          <div className="features-container">
            <div className="feature-card">
              <div className="feature-icon">
                <FaCalendarAlt />
              </div>
              <h3>Más de 40 años de experiencia</h3>
              <p>Fundados en 1982, contamos con una larga trayectoria brindando atención especializada y de calidad.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaUserFriends />
              </div>
              <h3>Equipo interdisciplinario</h3>
              <p>Profesionales especializados trabajan en conjunto para ofrecer una atención integral y personalizada.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <FaHandHoldingHeart />
              </div>
              <h3>Atención personalizada</h3>
              <p>Desarrollamos planes terapéuticos específicos para cada niño o joven, respetando sus tiempos y necesidades.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Sedes */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Nuestras Sedes</h2>
          <div className="services-container">
            <div className="service-card">
              <div className="service-image">
                <img src= {temperley_frente} alt="Sede Temperley" />
              </div>
              <div className="service-content">
                <h3>Sede Temperley</h3>
                <p>Ubicada en A. Gallardo 646, nuestra sede principal ofrece instalaciones completas y un ambiente cálido para el desarrollo de nuestras actividades.</p>
                <Link to="/temperley" className="btn" style={{ marginTop: '15px' }}>Conocer más</Link>
              </div>
            </div>

            <div className="service-card">
              <div className="service-image">
                <img src= {glew_frente} alt="Sede Glew" />
              </div>
              <div className="service-content">
                <h3>Sede Glew</h3>
                <p>Situada en RP210 Nº 22548, nuestra sede Glew proporciona un espacio amplio y adaptado para brindar todas nuestras terapias y actividades.</p>
                <Link to="/glew" className="btn" style={{ marginTop: '15px' }}>Conocer más</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>¿Necesitas más información?</h2>
          <p>Estamos aquí para ayudarte y responder todas tus preguntas. Contáctanos o visítanos en cualquiera de nuestras sedes.</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn btn">Contactar ahora</Link>
            <a
              href="#"
              className="btn btn-accent"
              onClick={(e) => {
                e.preventDefault();
                gtag_report_conversion("https://wa.me/5491165651675");
              }}
            >
              <FaWhatsapp /> Escribienos
            </a>
          </div>
        </div>
      </section>
       {/* WhatsApp Float Button With Report*/}
      <a
        href="#"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion("https://wa.me/5491165651675");
        }}
      >
        <FaWhatsapp />
      </a>
      {/* WhatsApp Float Button
      <a href="https://wa.me/5491165651675" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp />
      </a>
      */}

    </>
  );
};

export default LandingPage;